export enum BoardObjectTags {
    PieceBlue,
    PieceGreen,
    PieceOrange,
    Clock,
    Countdown,
    Coin,
    PieceYellow,
    PieceRed,
    TNT,
    Lightning,
    StaticBackground,
    PiecePurple,
    PiecePink,
    Fruit,
    PieceMoon,
    PieceBrown,
    PieceTurquoise,
    BonusCountdown,
    Blocker,
}
